import { render, staticRenderFns } from "./ForgotPasswordForm.vue?vue&type=template&id=ee4f07a4&scoped=true&"
import script from "./ForgotPasswordForm.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordForm.vue?vue&type=style&index=0&id=ee4f07a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4f07a4",
  null
  
)

export default component.exports